// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2Etjx","question":"Question_question__1eNqG","description":"Question_description__1O-Wi"};